const toHex = (buffer) => [...new Uint8Array(buffer)].map((byte) => byte.toString(16).padStart(2, '0')).join('');

export const sha256 = async (text) => {
  if (!window.crypto?.subtle) return null;
  const bytes = new TextEncoder().encode(text);
  return toHex(await window.crypto.subtle.digest('SHA-256', bytes));
};

export const verifyStreamIntegrity = async ({ text, completion, expectedTurnId, tokenSequences }) => {
  if (!completion?.stream_complete || !completion?.done) throw new Error('The AI response stream ended before completion.');
  if (!completion.finish_reason) throw new Error('The AI response did not provide a finish reason.');
  if (completion.turn_id && completion.turn_id !== expectedTurnId) throw new Error('The AI response belongs to a stale turn.');
  if (completion.byte_count !== new TextEncoder().encode(text).length) throw new Error('The AI response length did not match completion metadata.');
  if (completion.token_count !== tokenSequences.length) throw new Error('The AI response token count was incomplete.');
  const ordered = tokenSequences.every((sequence, index) => sequence === index + 1);
  if (!ordered) throw new Error('The AI response token sequence was incomplete.');
  const checksum = await sha256(text);
  if (checksum && checksum !== completion.checksum) throw new Error('The AI response checksum did not match.');
  return true;
};
